<div *ngIf="columnDefinitions.length >0">
  <mat-card>
    <mat-card-header>
      <mat-card-title class="mat-card-title-custom">{{'title.contract_moha' | translate}}
      </mat-card-title>
    </mat-card-header>
    <mat-card-content class="mb-3 mat-card-content-contract-sm">
      <!-- Filter -->
      <mat-accordion #accordion="matAccordion" [multi]="true">
        <mat-expansion-panel expanded="true" class="mt-3">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{'enterprise_contract.ttl_search' | translate}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <form #myForm="ngForm" (ngSubmit)="onFilterData(0, paginate.pageSize)" class="pb-3">
            <div class="row">
              <!-- Tên/số tài liệu -->
              <div class="col-lg-3 col-md-6">
                <mat-form-field class="w-100">
                  <input type="text"
                    (focusout)="documents.nameOrCode = documents.nameOrCode == undefined ? '' : (documents.nameOrCode + '').trim()"
                    #focusInput matInput [placeholder]="'search_form.doc_name_or_code' | translate" name="nameOrCode"
                    [(ngModel)]="documents.nameOrCode" maxlength="200" autocomplete="off">
                  <button mat-button *ngIf="documents.nameOrCode" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="documents.nameOrCode=''">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>

              <!-- Email/tên khách hàng -->
              <div class="col-lg-3 col-md-6">
                <mat-form-field class="w-100">
                  <input type="text"
                    (focusout)="documents.customerName = documents.customerName == undefined ? '' : (documents.customerName + '').trim()"
                    matInput [placeholder]="'search_form.code_custommer_name_or_email' | translate" name="customerName"
                    [(ngModel)]="documents.customerName" maxlength="200" autocomplete="off">
                  <button mat-button *ngIf="documents.customerName" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="documents.customerName=''">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>

              <!-- Trạng thái -->
              <div class="col-lg-3 col-md-6">
                <mat-form-field class="w-100">
                  <mat-label>{{'search_form.status' | translate}}</mat-label>
                  <mat-select #statusSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                    (focus)="commonService.openComboBox(checkFocus, statusSelect)" id="status" name="status"
                    [(ngModel)]="documents.status" (ngModelChange)="changeContractStatus()" [disabled]="!myForm.valid">
                    <mat-option [value]="''" selected (click)="this.commonService.closeDropdownList(this.statusSelect)">
                      {{'form.select_all' | translate}}</mat-option>
                    <mat-option [value]="enumContractStatus.DRAFT"
                      (click)="this.commonService.closeDropdownList(this.statusSelect)">
                      {{'search_form.draft' | translate}}</mat-option>
                    <mat-option [value]="enumContractStatus.PROCESSING"
                      (click)="this.commonService.closeDropdownList(this.statusSelect)">
                      {{'search_form.processing' | translate}}</mat-option>
                    <mat-option [value]="enumContractStatus.REJECTED"
                      (click)="this.commonService.closeDropdownList(this.statusSelect)">
                      {{'search_form.denied_sign' | translate}}</mat-option>
                    <mat-option [value]="enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT" *ngIf="isNotAttestedUser"
                      (click)="this.commonService.closeDropdownList(this.statusSelect)">
                      {{'search_form.wait_confirm_enterprice_no_moit' | translate}}</mat-option>
                    <mat-option [value]="enumContractStatus.FINISHED"
                      (click)="this.commonService.closeDropdownList(this.statusSelect)">
                      {{'search_form.finish' | translate}}</mat-option>
                    <mat-option [value]="enumContractStatus.CANCELLED"
                      (click)="this.commonService.closeDropdownList(this.statusSelect)">
                      {{'search_form.cancelled' | translate}}</mat-option>
                    <mat-option [value]="enumContractStatus.CONNECTING" *ngIf="!isNotAttestedUser"
                      (click)="this.commonService.closeDropdownList(this.statusSelect)">
                      {{'search_form.connecting' | translate}}</mat-option>
                    <mat-option [value]="enumContractStatus.TERMINATING"
                      (click)="this.commonService.closeDropdownList(this.statusSelect)">
                      {{'contract_terminate.terminating' | translate}}</mat-option>
                    <mat-option [value]="enumContractStatus.TERMINATED"
                      (click)="this.commonService.closeDropdownList(this.statusSelect)">
                      {{'contract_terminate.terminated' | translate}}</mat-option>
                      <!-- <mat-option [value]="enumContractStatus.TERMINATING_CONTRACT"
                      (click)="this.commonService.closeDropdownList(this.statusSelect)">
                      {{'contract_terminate.terminating_contract' | translate}}</mat-option> -->
                      <mat-option [value]="enumContractStatus.TERMINATED_CONTRACT"
                      (click)="this.commonService.closeDropdownList(this.statusSelect)">
                      {{'contract_terminate.terminated_contract' | translate}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Loại dịch vụ -->
              <div class="col-lg-3 col-md-6">
                <mat-form-field class="w-100">
                  <mat-label>{{'form.service_type' | translate}}</mat-label>
                  <mat-select #serviceTypeSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                    (focus)="commonService.openComboBox(checkFocus, serviceTypeSelect)" id="serviceType"
                    [disabled]="!myForm.valid" name="serviceType" [(ngModel)]="documents.serviceType"
                    (ngModelChange)="onSearch(0, paginate.pageSize)">
                    <mat-option>
                      <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                        [placeholderLabel]="'search_form.search' | translate" [formControl]="serviceTypesFilterCtrl">
                      </ngx-mat-select-search>
                    </mat-option>
                    <mat-option value="null" selected
                      (click)="this.commonService.closeDropdownList(this.serviceTypeSelect)">
                      {{'form.select_all' | translate}}
                    </mat-option>
                    <div class="service-type-loading" *ngIf="isServiceTypesLoading">
                      <i class="fa fa-circle-o-notch fa-spin"></i>
                    </div>
                    <mat-option *ngFor="let serviceType of filteredServiceTypes | async" [value]="serviceType.id"
                      (click)="this.commonService.closeDropdownList(this.serviceTypeSelect)">
                      {{serviceType.name}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <!-- Thời gian lập (từ ngày) -->
              <div class="col-lg-3 col-md-6" *ngIf="!isBasicSearchForm">
                <mat-form-field class="w-100">
                  <mat-label>{{ 'search_form.created_date_from' | translate }}</mat-label>
                  <input matInput [matDatepicker]="createdTimeFrom" [max]="documents.createdTimeTo"
                    #createdTimeFromCtrl="ngModel"
                    (change)="this.commonService.resetDatePicker(pickerInput.value, this.ngForm.controls['createdTimeFrom'])"
                    name="createdTimeFrom" #pickerInput [(ngModel)]="documents.createdTimeFrom" maxlength="200"
                    (focus)="createdDateErr = 'fromDate'" autocomplete="off" />
                  <mat-datepicker-toggle matSuffix [for]="createdTimeFrom">
                    <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                      [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                  </mat-datepicker-toggle>
                  <mat-datepicker #createdTimeFrom></mat-datepicker>
                  <mat-error *ngIf="createdTimeFromCtrl?.errors?.matDatepickerParse">
                    {{'validation.format_of_date' | translate}}
                  </mat-error>
                  <mat-error *ngIf="createdTimeFromCtrl?.errors?.matDatepickerMax && createdDateErr == 'fromDate'">
                    {{ 'search_form.created_date_from' | translate }}
                    {{ 'validation.from_date_smaller_than_or_equal_to_date' | translate }}
                    {{ 'search_form.created_date_to' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Thời gian lập (đến ngày) -->
              <div class="col-lg-3 col-md-6" *ngIf="!isBasicSearchForm">
                <mat-form-field class="w-100">
                  <mat-label>{{ 'search_form.created_date_to' | translate }}</mat-label>
                  <input matInput [matDatepicker]="createdTimeToRef" [min]="documents.createdTimeFrom"
                    (change)="this.commonService.resetDatePicker(pickerInput1.value, this.ngForm.controls['createdTimeTo'])"
                    name="createdTimeTo" #pickerInput1 [(ngModel)]="documents.createdTimeTo"
                    #createdTimeToCtrl="ngModel" maxlength="200" (focus)="createdDateErr = 'toDate'"
                    autocomplete="off" />
                  <mat-datepicker-toggle matSuffix [for]="createdTimeToRef">
                    <i matDatepickerToggleIcon class="fa fa-calendar" aria-hidden="true"
                      [matTooltip]="'enterprise_contract.tooltips.pick_date' | translate"></i>
                  </mat-datepicker-toggle>
                  <mat-datepicker #createdTimeToRef></mat-datepicker>
                  <mat-error *ngIf="createdTimeToCtrl?.errors?.matDatepickerParse">
                    {{'validation.format_of_date' | translate}}
                  </mat-error>
                  <mat-error *ngIf="createdTimeToCtrl?.errors?.matDatepickerMin && createdDateErr == 'toDate'">
                    {{ 'search_form.created_date_to' | translate }}
                    {{ 'validation.to_date_larger_than_or_equal_from_date' | translate }}
                    {{ 'search_form.created_date_from' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Vai trò ký -->
              <div class="col-md-6 col-lg-3" *ngIf="!isBasicSearchForm">
                <mat-form-field class="w-100">
                  <mat-label>{{'search_form.user_role_title' | translate}}</mat-label>
                  <mat-select #signRoleSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                    (focus)="commonService.openComboBox(checkFocus, signRoleSelect)" id="signRole" name="signRole"
                    [(ngModel)]="documents.signRole" (ngModelChange)="signRoleChanged($event)">
                    <mat-option value="null" selected
                      (click)="this.commonService.closeDropdownList(this.signRoleSelect)">
                      {{'search_form.user_role' | translate}}</mat-option>
                    <mat-option [value]="enumContractUserRole.SIGN"
                      (click)="this.commonService.closeDropdownList(this.signRoleSelect)">
                      {{'search_form.sign_doc' | translate}}</mat-option>
                    <mat-option [value]="enumContractUserRole.APPROVE"
                      (click)="this.commonService.closeDropdownList(this.signRoleSelect)">
                      {{'search_form.approve_doc' | translate}}</mat-option>
                    <mat-option [value]="enumContractUserRole.INITIAL"
                      (click)="this.commonService.closeDropdownList(this.signRoleSelect)">
                      {{'search_form.initial_doc' | translate}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Email/tên/số điện thoại -->
              <div class="col-md-6 col-lg-3" *ngIf="!isBasicSearchForm">
                <mat-form-field class="w-100">
                  <input type="text"
                    (focusout)="documents.nameOrEmailOrPhoneUserSign = documents.nameOrEmailOrPhoneUserSign == undefined ? '' : (documents.nameOrEmailOrPhoneUserSign + '').trim()"
                    matInput [placeholder]="'search_form.name_phome_email_process' | translate"
                    name="nameOrEmailOrPhoneUserSign" #nameOrEmailOrPhoneUserSign="ngModel"
                    [(ngModel)]="documents.nameOrEmailOrPhoneUserSign" maxlength="200" autocomplete="off"
                    [disabled]="isDisableNamePhoneEmail" required>
                  <button mat-button *ngIf="documents.nameOrEmailOrPhoneUserSign" type="button" matSuffix
                    mat-icon-button aria-label="Clear" (click)="documents.nameOrEmailOrPhoneUserSign=''">
                    <mat-icon>close</mat-icon>
                  </button>
                  <mat-error *ngIf="nameOrEmailOrPhoneUserSign.invalid && nameOrEmailOrPhoneUserSign?.errors?.required">
                    {{'validation.name_phone_email_user_sign_require' | translate}}
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- UUID Hợp đồng -->
              <div class="col-md-6 col-lg-3" *ngIf="!isBasicSearchForm">
                <mat-form-field class="w-100">
                  <input type="text" matInput [placeholder]="'search_form.uuid_contract' | translate"
                    name="uuidContractMoha" #uuidContract="ngModel" [(ngModel)]="documents.uuidContractMoha" maxlength="50"
                    autocomplete="off" (blur)="trimInput('uuidContractMoha')">
                  <button mat-button *ngIf="documents.uuidContractMoha" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="documents.uuidContractMoha=''">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>


              <!-- Phương thức lập -->
              <div class="col-lg-3 col-md-6" *ngIf="!isBasicSearchForm">
                <mat-form-field class="w-100">
                  <mat-label>{{'search_form.method_creation' | translate}}</mat-label>
                  <mat-select #typeIdSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                    (focus)="commonService.openComboBox(checkFocus, typeIdSelect)" id="typeId" name="typeId"
                    [(ngModel)]="documents.typeId" (ngModelChange)="onClickBtnFilter()" [disabled]="!myForm.valid">
                    <mat-option [value]="''" selected (click)="this.commonService.closeDropdownList(this.typeIdSelect)">
                      {{'form.select_all' | translate}}</mat-option>
                    <mat-option [value]="1" (click)="this.commonService.closeDropdownList(this.typeIdSelect)">
                      {{'search_form.upload' | translate}}</mat-option>
                    <mat-option [value]="0" (click)="this.commonService.closeDropdownList(this.typeIdSelect)">
                      {{'search_form.template' | translate}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- THương thảo HĐ/VB -->
              <div class="col-lg-3 col-md-6" *ngIf="!isBasicSearchForm">
                <mat-form-field class="w-100">
                  <mat-label>{{'negotiate_contract.label' | translate}}</mat-label>
                  <mat-select #negotiateSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                    (focus)="commonService.openComboBox(checkFocus, negotiateSelect)" id="negotiate" name="negotiate"
                    [(ngModel)]="documents.negotiate" (ngModelChange)="onClickBtnFilter()">
                    <mat-option [value]="''" selected
                      (click)="this.commonService.closeDropdownList(this.negotiateSelect)">
                      {{'form.select_all' | translate}}</mat-option>
                    <mat-option [value]="1" (click)="this.commonService.closeDropdownList(this.negotiateSelect)">
                      {{'button.yes_sign_method_default' | translate}}</mat-option>
                    <mat-option [value]="0" (click)="this.commonService.closeDropdownList(this.negotiateSelect)">
                      {{'button.no' | translate}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Trạng thái chứng thực -->
              <div class="col-lg-3 col-md-6" *ngIf="!isBasicSearchForm">
                <mat-form-field class="w-100">
                  <mat-label>{{'contract_terminate.status_sign' | translate}}</mat-label>
                  <mat-select #formTypeSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                    (focus)="commonService.openComboBox(checkFocus, formTypeSelect)" id="mohaConfirmStatus" name="mohaConfirmStatus"
                    [(ngModel)]="documents.mohaConfirmStatus" (ngModelChange)="onClickBtnFilter()" [disabled]="!myForm.valid">
                    <mat-option [value]="''" selected
                      (click)="this.commonService.closeDropdownList(this.formTypeSelect)">
                      {{'form.select_all' | translate}}</mat-option>
                    <mat-option [value]="1"
                      (click)="this.commonService.closeDropdownList(this.formTypeSelect)">
                      {{'contract_terminate.no_sign' | translate}}</mat-option>
                    <mat-option [value]="2"
                      (click)="this.commonService.closeDropdownList(this.formTypeSelect)">
                      {{'contract_terminate.signing' | translate}}</mat-option>
                    <mat-option [value]="3"
                      (click)="this.commonService.closeDropdownList(this.formTypeSelect)">
                      {{'contract_terminate.failed' | translate}}</mat-option>
                    <mat-option [value]="6"
                      (click)="this.commonService.closeDropdownList(this.formTypeSelect)">
                      {{'contract_terminate.signed' | translate}}</mat-option>
                    <!-- <mat-option [value]="5"
                      (click)="this.commonService.closeDropdownList(this.formTypeSelect)">
                      {{'contract_terminate.wait_sign_again' | translate}}</mat-option> -->
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- Trạng thái gửi lên Nền tảng HDLD -->
              <div class="col-lg-3 col-md-6" *ngIf="!isBasicSearchForm">
                <mat-form-field class="w-100">
                  <mat-label>{{'contract_terminate.status_send_up' | translate}}</mat-label>
                  <mat-select #formTypeSelectSend (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                    (focus)="commonService.openComboBox(checkFocus, formTypeSelectSend)" id="mohaStatus" name="mohaStatus"
                    [(ngModel)]="documents.mohaStatus" (ngModelChange)="onClickBtnFilter()" [disabled]="!myForm.valid">
                    <mat-option [value]="''" selected
                      (click)="this.commonService.closeDropdownList(this.formTypeSelectSend)">
                      {{'form.select_all' | translate}}</mat-option>
                    <mat-option [value]="1"
                      (click)="this.commonService.closeDropdownList(this.formTypeSelectSend)">
                      {{'contract_terminate.no_send' | translate}}</mat-option>
                    <mat-option [value]="2"
                      (click)="this.commonService.closeDropdownList(this.formTypeSelectSend)">
                      {{'contract_terminate.sending' | translate}}</mat-option>
                    <mat-option [value]="3"
                      (click)="this.commonService.closeDropdownList(this.formTypeSelect)">
                      {{'sign_contract_flow.error' | translate}}</mat-option>
                      <mat-option [value]="4"
                      (click)="this.commonService.closeDropdownList(this.formTypeSelectSend)">
                      {{'contract_terminate.sent' | translate}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <!-- Hình thức tài liệu -->
              <div class="col-lg-3 col-md-6" *ngIf="!isBasicSearchForm">
                <mat-form-field class="w-100">
                  <mat-label>{{'contract_terminate.form_type' | translate}}</mat-label>
                  <mat-select #formTypeSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                    (focus)="commonService.openComboBox(checkFocus, formTypeSelect)" id="formType" name="formType"
                    [(ngModel)]="documents.formType" (ngModelChange)="onClickBtnFilter()" [disabled]="!myForm.valid">
                    <mat-option [value]="''" selected
                      (click)="this.commonService.closeDropdownList(this.formTypeSelect)">
                      {{'form.select_all' | translate}}</mat-option>
                    <mat-option [value]="'CONTRACT'"
                      (click)="this.commonService.closeDropdownList(this.formTypeSelect)">
                      {{'add_document_moha.employment_contract' | translate}}</mat-option>
                    <mat-option [value]="'CONTRACT_APPENDIX'"
                      (click)="this.commonService.closeDropdownList(this.formTypeSelect)">
                      {{'add_document_moha.employment_contract_addendum' | translate}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <!-- button up/down -->
              <div *ngIf="!isBasicSearchForm" class="col-lg-12 col-md-6 d-flex justify-content-end">
                <button type="button" mat-button class="advance-search"
                  (click)="onCloseAdvancedSearchForm()">
                  <span>{{'enterprise_contract.buttons.basic' | translate}}</span>
                  <em class="material-icons">keyboard_arrow_up</em>
                </button>
              </div>

              <div *ngIf="isBasicSearchForm" class="col-lg-12 col-md-6 d-flex justify-content-end">
                <button type="button" mat-button class="advance-search"
                  (click)="onExpandAdvancedSearchForm()">
                  <span>{{'enterprise_contract.buttons.advance' | translate}}</span>
                  <em class="material-icons">keyboard_arrow_down</em>
                </button>
              </div>

              <!-- button tìm kiếm -->
              <div class="col-lg-12 col-md-6 d-flex justify-content-center">
                <div class="row mt-3">
                  <div class="col-lg-12 d-flex align-items-center justify-content-center">
                    <button mat-stroked-button color="primary" appTrackEvent="w.btn.hdtoilap.tim_kiem"
                      [disabled]="!myForm.valid || isTableLoading">
                      <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
                      {{'enterprise_contract.buttons.search' | translate}}
                    </button>
                  </div>
                </div>
              </div>
            </div>


          </form>
        </mat-expansion-panel>
      </mat-accordion>

      <mat-accordion #accordion="matAccordion" [multi]="true">
        <mat-expansion-panel expanded="true" class="mt-3">
          <mat-panel-title class="mat-panel-title mb-2 pb-3 mt-3 d-flex align-items-center list-title-mine ">
            <div class="row">
              <div class="col-12"><span class="">{{'enterprise_contract.list_contract_moha' | translate}}
                  ({{paginate.totalRow}})
                  <span *ngIf="!commonService.getIsLockedEnterprise()">,&nbsp;{{'enterprise_contract.selected' |
                    translate}}
                    {{this.dataSelected.size}}</span>
                </span></div>
              <div class="col-12">
                <div *ngIf="isProcess" class="col-12" layout-align="center center end-start">
                  <div class="row">
                    <div class="col-9">
                      <span *ngIf="checkMan == 1" style="margin-left: -12px;">{{'messages.signing_multi_progress' |
                        translate}} {{percent}} %</span>
                      <span *ngIf="checkMan == 2" style="margin-left: -12px;">{{'messages.cancel_contract_lot' |
                        translate}} {{percent}} %</span>
                      <span *ngIf="checkMan == 3" style="margin-left: -12px;">{{'messages.signing_progress_lot' |
                        translate}} {{percent}} %</span>
                      <span *ngIf="checkMan == 4" style="margin-left: -12px;">{{'messages.signing_multi_progress' |
                        translate}} {{percent}} %</span>
                      <span *ngIf="checkMan == 5" style="margin-left: -12px;">{{'messages.deleting_progress_lot' |
                        translate}} {{percent}} %</span>
                      <span *ngIf="checkMan == 6" style="margin-left: -12px;">{{'messages.deleting_progress_lot' |
                        translate}} {{percent}} %</span>
                      <mat-progress-bar style="margin-left: -12px;" mode="determinate" [value]="percent"
                        [bufferValue]="100">
                      </mat-progress-bar>
                    </div>
                    <div class="col-1" layout="row" layout-align="end center" style="margin-left: -30px;">
                      <button *ngIf="checkMan == 1" class="btn1-mine" mat-icon-button color="primary"
                        (click)="openMutipleSignDocument(false)" matTooltip="">
                        <mat-icon>play_circle_outline</mat-icon>
                      </button>
                      <button *ngIf="checkMan == 3" class="btn1-mine" mat-icon-button color="primary"
                        (click)="signatureProcess()" matTooltip="">
                        <mat-icon>play_circle_outline</mat-icon>
                      </button>
                      <button *ngIf="checkMan == 2" class="btn1-mine" mat-icon-button color="primary"
                        (click)="cancelFlow()" matTooltip="">
                        <mat-icon>play_circle_outline</mat-icon>
                      </button>
                      <button *ngIf="checkMan == 4" class="btn1-mine" mat-icon-button color="primary"
                        (click)="openMutipleSignDocument(true)" matTooltip="">
                        <mat-icon>play_circle_outline</mat-icon>
                      </button>
                      <button *ngIf="checkMan == 5" class="btn1-mine" mat-icon-button color="primary"
                        (click)="deleteAll(false)" matTooltip="">
                        <mat-icon>play_circle_outline</mat-icon>
                      </button>
                      <button *ngIf="checkMan == 6" class="btn1-mine" mat-icon-button color="primary"
                        (click)="deleteAll(true)" matTooltip="">
                        <mat-icon>play_circle_outline</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <button    mat-stroked-button color="primary" type="button" (click)="openMutipleSignDocument()"
                    *ngIf="!warningContractQuantity && mediaBreakpoint !== SCREEN_SIZE.XS && mediaBreakpoint !== SCREEN_SIZE.SM && !commonService.getIsLockedEnterprise()"
                    [disabled]="this.dataSelected.size === 0 || this.dataSource === null || this.dataSource.data === null
                || this.dataSource.data.value === null
                || this.dataSource.data.value.length === 0">
              <mat-icon class="mr-0">play_circle_outline</mat-icon>
              {{'button.sign_contract' | translate}}
            </button> -->
            <!--          <div class="" [ngClass]="mediaBreakpoint === SCREEN_SIZE.MD ? 'buttonMD d-flex flex-row-reverse justify-content-end' : ''" >-->
            <div class="buttonMD">
              <button class="btn1-mine" style="position: absolute; right: 286px" mat-stroked-button color="primary"
                type="button" (click)="onAddDocument()" appTrackEvent="w.btn.hdtoilap.them_moi"
                *ngIf="!warningContractQuantity && mediaBreakpoint !== SCREEN_SIZE.XS && mediaBreakpoint !== SCREEN_SIZE.SM && !commonService.getIsLockedEnterprise() && checkPermissionCreateContract()">
                <mat-icon class="mr-0">add_circle</mat-icon>
                {{'button.add' | translate}}
              </button>
              <button class="btn1-mine " style="position: absolute; right: 147px" mat-stroked-button color="primary" type="button"
                      (click)="onAddLot()" appTrackEvent="w.btn.hdtoilap.them_moi_lo"
                      *ngIf="!warningContractQuantity && mediaBreakpoint !== SCREEN_SIZE.XS && mediaBreakpoint !== SCREEN_SIZE.SM && !commonService.getIsLockedEnterprise() && checkPermissionCreateContract()">
                <mat-icon class="mr-0">note_add</mat-icon>
                {{'button.add_lot' | translate}}
              </button>
              <button class="btn1-mine" style="position: absolute; right: 24px;" mat-stroked-button color="primary"
                type="button" [matMenuTriggerFor]="menuFeature" (click)="closeMenu()"
                appTrackEvent="w.btn.hdtoilap.khac">
                <mat-icon>apps</mat-icon>
                {{'button.more_feature' | translate}}
              </button>
            </div>
            <!-- <button class="pull-right" mat-stroked-button color="warn"
                    (click)="deleteAll(this.dataSelected.size)"
                    [disabled]="this.dataSelected.size === 0 || this.dataSource === null || this.dataSource.data === null
                || this.dataSource.data.value === null
                || this.dataSource.data.value.length === 0
                || commonService.getIsLockedEnterprise()">
              <mat-icon class="mr-0">delete</mat-icon>
              {{'button.delete' | translate}}
            </button> -->
            <!--          <button [matMenuTriggerFor]="menuColumn" [matTooltip]="'bodytable.status_column' | translate" class="btn1-mine "-->
            <!--                  style="position: absolute;width: 35px; padding: 6px 5px 3px 5px;border-radius: 5px; right: 24px;border: 1px solid #bdbdbd;  align-items: center;"-->
            <!--                  color="primary" type="button"-->
            <!--                   >-->
            <!--            <mat-icon>more_vert</mat-icon>-->
            <!--          </button >-->

            <mat-menu #menuColumn="matMenu">
              <mat-checkbox style="margin: 0px 15px" [(ngModel)]="isCheckedAllColumn" (click)="$event.stopPropagation()"
                (change)="onAllColumnCheckboxChange(isCheckedAllColumn)">{{ 'form.select_all_group' | translate}}
              </mat-checkbox>
              <div *ngFor="let option of columnDefinitions">
                <mat-checkbox style="margin: 0px 15px" [(ngModel)]="option.default" (change)="onCheckboxChange(option)"
                  (click)="$event.stopPropagation()" [checked]="option.default" *ngIf="!option.check">{{ option.name |
                  translate}}</mat-checkbox>
              </div>
            </mat-menu>

            <!-- menu button -->
            <mat-menu #menuFeature="matMenu">
              <button class="btn1-mine" mat-menu-item class="other-button"
                *ngIf="!commonService.getIsLockedEnterprise()"
                style="border-bottom: 1px solid rgb(213 213 213) !important;" (click)=" $event.stopPropagation()"
                [matMenuTriggerFor]="menuColumn">
                <mat-icon class="mr-0 other-button">more_vert</mat-icon>
                {{'bodytable.status_column' | translate}}
              </button>

              <!-- <button class="btn1-mine other-button" mat-menu-item [ngClass]="{'other-button': !isProcess}"
                [disabled]="isProcess" type="button" (click)="openMenuSign() ; $event.stopPropagation()"
                *ngIf="!commonService.getIsLockedEnterprise() && checkPermissionCreateContract()" class="other-button"
                appTrackEvent="w.btn.hdtoilap.khac.thuchienluongky"
                style="border-bottom: 1px solid rgb(213 213 213) !important;margin-left: 0px !important; ">
                <mat-icon class="mr-0" [ngClass]="{'other-button': !isProcess}">play_circle_outline</mat-icon>
                {{'button.sign_contract' | translate}}
                <mat-icon class="mr-0 " [ngClass]="{'other-button': !isProcess}"
                  style="float: right !important; margin-top: 13px !important">{{ isShowMenuSign ? 'keyboard_arrow_down'
                  : 'keyboard_arrow_right'}}</mat-icon>
              </button> -->

              <!-- <button class="btn1-mine" mat-menu-item (click)="openMutipleSignDocument(false)" [disabled]=" this.dataSelected.size === 0 || this.dataSource === null || this.dataSource.data === null
                  || this.dataSource.data.value === null
                  || this.dataSource.data.value.length === 0" appTrackEvent="w.btn.hdtoilap.khac.thuchienluongky.list"
                [ngClass]="{'other-button': !isProcess && this.dataSelected.size !== 0 }"
                *ngIf="!commonService.getIsLockedEnterprise() && isShowMenuSign"
                style="border-bottom: 1px solid rgb(213 213 213) !important;padding-left: 55px !important;margin-left: 0px !important;"> -->
                <!--              {{'button.sign_contract' | translate}}-->
                <!-- {{'button.selected_contract' | translate}}
              </button>
              <button class="btn1-mine" mat-menu-item (click)="openMutipleSignDocument(true)"
                appTrackEvent="w.btn.hdtoilap.khac.thuchienluongky.all" [ngClass]="isProcess ? '' : 'other-button'"
                *ngIf="!commonService.getIsLockedEnterprise() && isShowMenuSign"
                style="border-bottom: 1px solid rgb(213 213 213) !important; ;padding-left: 55px !important;margin-left: 0px !important;"> -->
                <!--              {{'button.sign_contract_all' | translate}}-->
                <!-- {{'button.all_contract_draft' | translate}}
              </button> -->


              <!-- <button class="btn1-mine other-button" mat-menu-item [ngClass]="{'other-button': !isProcess}"
                [disabled]="isProcess" class="other-button" appTrackEvent="w.btn.hdtoilap.khac.xoa"
                *ngIf="!commonService.getIsLockedEnterprise()"
                style="border-bottom: 1px solid rgb(213 213 213) !important;margin-left: 0px !important;"
                (click)="openMenuDelete() ; $event.stopPropagation()">
                <mat-icon class="mr-0" [ngClass]="{'other-button': !isProcess}">delete</mat-icon>
                {{'button.delete' | translate}}
                <mat-icon class="mr-0 " [ngClass]="{'other-button': !isProcess}"
                  style="float: right !important; margin-top: 13px !important">{{ isShowMenuDelete ?
                  'keyboard_arrow_down' : 'keyboard_arrow_right'}}</mat-icon>

              </button> -->

              <!-- <button class="btn1-mine pl-4" mat-menu-item (click)="deleteAll(false)"
                [ngClass]="{'other-button': !isProcess && this.dataSelected.size !== 0 }"
                appTrackEvent="w.btn.hdtoilap.khac.xoa.hd_da_chon" [disabled]=" this.dataSelected.size === 0 || this.dataSource === null || this.dataSource.data === null
                  || this.dataSource.data.value === null
                  || this.dataSource.data.value.length === 0"
                *ngIf="!commonService.getIsLockedEnterprise() && isShowMenuDelete"
                style="border-bottom: 1px solid rgb(213 213 213) !important;padding-left: 55px !important;margin-left: 0px "> -->
                <!--              {{'button.delete' | translate}}-->
                <!-- {{'button.selected_contract' | translate}}
              </button> -->
              <!-- <button class="btn1-mine pl-4" mat-menu-item (click)="deleteAll(true)" class="other-button"
                appTrackEvent="w.btn.hdtoilap.khac.xoa.tat_ca_hd_da_chon"
                *ngIf="!commonService.getIsLockedEnterprise() && isShowMenuDelete"
                style="border-bottom: 1px solid rgb(213 213 213) !important;padding-left: 55px !important;"> -->
                <!--              {{'messages.delete_all_contract_draft' | translate}}-->
                <!-- {{'button.all_contract_draft' | translate}}
              </button> -->

              <!-- Tai nhieu -->
              <!-- <button class="btn1-mine" style="border-bottom: 1px solid rgb(213 213 213) !important;"
                [ngClass]="{'other-button': !isProcess && this.dataSelected.size !== 0 }"
                appTrackEvent="w.btn.hd_toi_lap.khac.tai_file" [disabled]=" this.dataSelected.size === 0 || this.dataSource === null || this.dataSource.data === null
                  || this.dataSource.data.value === null
                  || this.dataSource.data.value.length === 0 || isProcess" mat-menu-item class="other-button"
                (click)="multiDownload()">
                <mat-icon class="mr-0 " [ngClass]="{'other-button': !isProcess && this.dataSelected.size !== 0 }">
                  save_alt</mat-icon>
                {{'button.downloadContract' | translate}}
              </button> -->
              <!-- Trinh ky xac nhan -->
              <!-- <button class="btn1-mine" mat-menu-item class="other-button"
                style="border-bottom: 1px solid rgb(213 213 213) !important;"
                [ngClass]="{'other-button': !isProcess && this.dataSelected.size !== 0 }"
                appTrackEvent="w.btn.hdtoilap.khac.trinh_ky_xac_nhan" [disabled]=" this.dataSelected.size === 0 || this.dataSource === null || this.dataSource.data === null
                  || this.dataSource.data.value === null
                  || this.dataSource.data.value.length === 0  || isProcess" (click)="signatureProcess()"
                *ngIf="isNotAttestedUser ">
                <mat-icon class="mr-0 other-button"
                  [ngClass]="{'other-button': !isProcess && this.dataSelected.size !== 0 }">gesture</mat-icon>
                {{'enterprise_contract.buttons.signature_process' | translate}}
              </button> -->
              <!-- huy luong ky -->
              <button class="btn1-mine" mat-menu-item class="other-button" (click)="cancelFlow()"
                [ngClass]="{'other-button': !isProcess && this.dataSelected.size !== 0 }"
                appTrackEvent="w.btn.hdtoilap.khac.huy_luong_ky" [disabled]=" this.dataSelected.size === 0 || this.dataSource === null || this.dataSource.data === null
                  || this.dataSource.data.value === null
                  || this.dataSource.data.value.length === 0  || isProcess">
                <mat-icon class="mr-1 other-button"
                  [ngClass]="{'other-button': !isProcess && this.dataSelected.size !== 0 }">
                  block
                </mat-icon>
                {{'title.cancel_flow' | translate}}
              </button>
            </mat-menu>
          </mat-panel-title>
          <div class="mat-table-container table-container example-container" style=" display: block; max-height: 590px">
            <mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)"
              class="mat-table-col-extra-sm mat-table table" [ngStyle]="{'min-width': tableWidth + 'px'}">
              <!-- check -->
              <ng-container matColumnDef="check">
                <mat-header-cell *matHeaderCellDef
                  class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom">
                  <mat-checkbox [(ngModel)]="checkAll" (change)="checkAllCheckBox()" color="primary"></mat-checkbox>
                </mat-header-cell>
                <mat-cell *matCellDef="let element"
                  class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom "
                  (click)="$event.stopPropagation()">
                  <mat-checkbox color="primary" [(ngModel)]="element.checked" (change)="onSelect(element)">
                  </mat-checkbox>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell check-col">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!-- STT -->
              <ng-container matColumnDef="STT">
                <mat-header-cell *matHeaderCellDef
                  class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                  {{'enterprise_contract.table_headers.No' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element"
                  class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                  (click)="$event.stopPropagation()">
                  {{element.STT}}
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell no-col">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!-- UUID Hợp đồng -->
              <ng-container matColumnDef="uuidContractMoha">
                <mat-header-cell *matHeaderCellDef style="max-width: 30%;"
                  class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  {{'headertable.uuid_contract' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" matTooltip="{{ element.uuidContractMoha }}"
                  class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()" style="max-width: 30%;">
                  <span class="fix-width">{{ element.uuidContractMoha }}</span>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 30%;">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!-- Khách hàng Column -->
              <ng-container matColumnDef="allName">
                <mat-header-cell *matHeaderCellDef style="max-width: 30%;"
                  class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  {{'headertable.contract_parties' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" matTooltip="{{ element.allName }}"
                  class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()" style="max-width: 30%;">
                  <span class="fix-width">{{ element.allName }}</span>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 30%;">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>


              <!-- Tài liệu Column -->
              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef mat-sort-header style="width: 20%;"
                  class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  {{'headertable.document_code_name' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom" style="width: 20%;">
                  <!-- <button *ngIf="element.hasChildren == 1" (click)="expandedParent(element.id)" mat-icon-button
                    color="primary" style="margin-left: -10px;">
                    <mat-icon id="expand_more" [matTooltip]="'enterprise_contract.tooltips.btn_expand_more' | translate"
                      #expand_more *ngIf="!element.close">add
                    </mat-icon>
                    <mat-icon id="expand_less" [matTooltip]="'enterprise_contract.tooltips.btn_expand_less' | translate"
                      #expand_less *ngIf="element.close">remove
                    </mat-icon>
                  </button> -->
                  <span (click)="$event.stopPropagation()" matTooltip="{{element.name}}" class="fix-width"
                    style="margin-left: -5px;">
                    {{element.name}}
                  </span>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="width: 20%;">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>



              <!-- Email các bên ký hợp đồng Column -->
              <ng-container matColumnDef="allEmail">
                <mat-header-cell *matHeaderCellDef style="max-width: 15%;"
                  class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  {{'headertable.contract_parties_email' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" matTooltip="{{ element.allEmail }}"
                  class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()" style="max-width: 15%;">
                  <span class="fix-width">{{ element.allEmail }}</span>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 15%;">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!-- Loai hop dong -->
              <ng-container matColumnDef="serviceTypeName">
                <mat-header-cell *matHeaderCellDef style="max-width: 15%;"
                  class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  <span>
                    {{'form.service_type' | translate}}
                  </span>
                </mat-header-cell>
                <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"
                  matTooltip="{{element.serviceTypeName}}" class="mat-cell-non-boder-right-bottom"
                  style="max-width: 15%;">
                  <span class="fix-width">{{ element.serviceTypeName }}</span>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 15%;">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!-- Trạng thái Column -->
              <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef class="doc-status-col mat-cell-non-boder-right-bottom"
                  style="max-width: 10%;">
                  {{'enterprise_contract.table_headers.document_status' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element"
                  class="doc-status-col mat-cell-non-boder-right-bottom number-cell-center && element.isTerminated == false" style="max-width: 10%;"
                  (click)="$event.stopPropagation()">
                  <nz-tag *ngIf="element.status === enumContractStatus.DRAFT && element.isTerminated == false" style="margin-right: 0px;">
                    {{'search_form.draft' | translate}}</nz-tag>
                  <nz-tag *ngIf="element.status === enumContractStatus.PROCESSING && element.isTerminated == false" [nzColor]="'blue'"
                    style="margin-right: 0px;">{{'search_form.processing' | translate}}
                  </nz-tag>
                  <nz-tag *ngIf="element.status === enumContractStatus.REJECTED && element.isTerminated == false" [nzColor]="'red'"
                    style="margin-right: 0px;">{{'search_form.denied_sign' | translate}}
                  </nz-tag>
                  <nz-tag
                    *ngIf="element.status === enumContractStatus.FINISHED && element.contractTerminationStatus != 2 && element.contractTerminationStatus != 4 && element.isTerminated == false"
                    [nzColor]="'green'" style="margin-right: 0px;">{{'search_form.finish' | translate}}</nz-tag>
                  <nz-tag *ngIf="element.status === enumContractStatus.CANCELLED && element.isTerminated == false" [nzColor]="'red'"
                    style="margin-right: 0px;">{{'search_form.cancelled' | translate}}</nz-tag>
                  <nz-tag *ngIf="element.status == enumContractStatus.CONNECTING && element.isTerminated == false" [nzColor]="'blue'"
                    style="margin-right: 0px;">{{'search_form.connecting' | translate}}</nz-tag>
                  <nz-tag *ngIf="element.status == enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT && element.isTerminated == false"
                    class='wait-confirm-enterprice-no-moit__tag' style="margin-right: 0px;">
                    {{'search_form.wait_confirm_enterprice_no_moit' | translate}}</nz-tag>
                  <nz-tag
                    *ngIf="element.status == enumContractStatus.FINISHED && element.contractTerminationStatus == 2 && element.isTerminated == false"
                    [nzColor]="'blue'" style="margin-right: 0px;">{{'contract_terminate.terminating' | translate}}
                  </nz-tag>
                  <nz-tag
                    *ngIf="element.status == enumContractStatus.FINISHED && element.contractTerminationStatus == 4 && element.isTerminated == false"
                    [nzColor]="'green'" style="margin-right: 0px;">{{'contract_terminate.terminated' | translate}}
                  </nz-tag>
                  <!-- <nz-tag
                    *ngIf="element.isTerminated == false"
                    [nzColor]="'blue'" style="margin-right: 0px;">{{'contract_terminate.terminating_contract' | translate}}
                  </nz-tag> -->
                  <nz-tag
                    *ngIf="element.isTerminated == true"
                    [nzColor]="'red'" style="margin-right: 0px;">{{'contract_terminate.terminated_contract' | translate}}
                  </nz-tag>
                  <!-- <div nz-tooltip [nzTooltipTitle]="getCECAStatus(element)"
                    *ngIf="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable">
                    <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.FINISHED" nzStatus="success">
                    </nz-badge>
                    <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.REJECTED" nzStatus="error">
                    </nz-badge>
                    <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.PROCESSING" nzStatus="processing">
                    </nz-badge>
                  </div> -->
                  <div *ngIf="element.identifyStatus == 3" style="font-size: 16px;"
                    [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"
                    class="d-flex align-items-center" nz-tooltip
                    nzTooltipTitle="{{'enterprise_contract.identity_refused' | translate}}">
                    <span class="text-primary" nz-icon nzType="close-circle" nzTheme="outline"></span>
                  </div>
                  <div *ngIf="element.identifyStatus == 4" style="font-size: 16px;"
                    [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"
                    class="d-flex align-items-center" nz-tooltip
                    nzTooltipTitle="{{'enterprise_contract.unidentified' | translate}}">
                    <i class="fa fa-hourglass-end" style="color: orange;" aria-hidden="true"></i>
                  </div>
                  <div *ngIf="element.identifyStatus == 5" style="font-size: 16px;"
                    [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"
                    class="d-flex align-items-center" nz-tooltip
                    nzTooltipTitle="{{'enterprise_contract.identified' | translate}}">
                    <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>
                  </div>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell doc-status-col" style="max-width: 10%;">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!-- Trạng thái gửi bộ công thương -->
              <!-- <ng-container matColumnDef="bctConfirmStatus">
                <mat-header-cell *matHeaderCellDef style="max-width: 7%;"
                  class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  {{'headertable.send_bct' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom"
                  (click)="$event.stopPropagation()" style="max-width: 7%; justify-content: center;">
                  <div *ngIf="getConfirmBCTStastus(element)" [matTooltip]="getConfirmBCTStastus(element) | translate">
                    <span *ngIf="element.bctConfirmStatus === 3">
                      <ng-container *ngTemplateOutlet="iconError"></ng-container>
                    </span>

                    <span *ngIf="element.bctConfirmStatus === 2">
                      <ng-container *ngTemplateOutlet="iconProcess"></ng-container>
                    </span>

                    <span *ngIf="element.bctConfirmStatus === 4">
                      <ng-container *ngTemplateOutlet="iconFinish"></ng-container>
                    </span>
                  </div>
                </mat-cell>
              </ng-container> -->

              <!-- Thời gian lập Column -->
              <ng-container matColumnDef="createdTime">
                <mat-header-cell *matHeaderCellDef mat-sort-header
                  class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  {{'enterprise_contract.table_headers.created_date' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                  [matTooltip]="element.createdTime | dateformat" (click)="$event.stopPropagation()">
                  <span class="fix-width">{{ element.createdTime | dateformat}}</span>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!-- người thực hiện -->
              <ng-container matColumnDef="userSign">
                <mat-header-cell *matHeaderCellDef style="min-width: 7%;" mat-sort-header
                  class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  <span>
                    {{'enterprise_contract.table_headers.user_sign' | translate}}
                  </span>
                </mat-header-cell>
                <mat-cell *matCellDef="let element" matTooltip="{{ element.userSign }}"
                  (click)="$event.stopPropagation()" class="mat-cell-non-boder-right-bottom" style="min-width: 7%;">
                  <span class="fix-width">{{ element.userSign }}</span>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="min-width: 7%;">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!-- vai trò -->
              <ng-container matColumnDef="role">
                <mat-header-cell *matHeaderCellDef style="max-width: 5%;" mat-sort-header
                  class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  <span>
                    {{'enterprise_contract.table_headers.role' | translate}}
                  </span>
                </mat-header-cell>
                <mat-cell *matCellDef="let element"
                  matTooltip="{{ (element.role === 1 ? 'search_form.sign_doc' : (element.role === 2 ? 'search_form.approve_doc' : (element.role === 3 ? 'search_form.initial_doc' : ''))) | translate}}"
                  (click)="$event.stopPropagation()" class="mat-cell-non-boder-right-bottom" style="max-width: 5%;">
                  <span *ngIf="element.role === 1" class="fix-width">{{'search_form.sign_doc' | translate}}</span>
                  <span *ngIf="element.role === 2" class="fix-width">{{'search_form.approve_doc' | translate}}</span>
                  <span *ngIf="element.role === 3" class="fix-width">{{'search_form.initial_doc' | translate}}</span>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="max-width: 5%;">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!-- Trạng thái bên nhận  -->
              <ng-container matColumnDef="statusRecipient">
                <mat-header-cell *matHeaderCellDef style="max-width: 10%;"
                  class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  {{'headertable.recipient_status' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element"
                  class="doc-status-col mat-cell-non-boder-right-bottom number-cell-center" style="max-width: 10%;"
                  (click)="$event.stopPropagation()">
                  <nz-tag *ngIf="element.statusRecipient === enumContractUserStatus.STOP_PROCESS.toString()"
                    style="margin-right: 0px;">
                    {{'search_form.contract_user_status_stop_process' | translate}}</nz-tag>
                  <nz-tag *ngIf="element.statusRecipient === enumContractUserStatus.NO_PROCESS.toString()"
                    style="margin-right: 0px;">
                    {{'form.document_status_wait' | translate}}</nz-tag>
                  <nz-tag *ngIf="element.statusRecipient === enumContractUserStatus.PROCESSING.toString()"
                    [nzColor]="'blue'" style="margin-right: 0px;">{{'messages.sign_processing' | translate}}
                  </nz-tag>
                  <nz-tag *ngIf="element.statusRecipient === enumContractUserStatus.REJECTED.toString()"
                    [nzColor]="'red'" style="margin-right: 0px;">{{'search_form.contract_user_status_rejected' |
                    translate}}
                  </nz-tag>
                  <nz-tag *ngIf="element.statusRecipient === enumContractUserStatus.PROCESSED.toString()"
                    [nzColor]="'green'" style="margin-right: 0px;">{{'form.document_status_signed' | translate}}
                  </nz-tag>
                  <nz-tag *ngIf="element.statusRecipient === enumContractUserStatus.CANCELLED.toString()"
                    [nzColor]="'red'" style="margin-right: 0px;">{{'search_form.cancelled' | translate}}</nz-tag>
                  <nz-tag *ngIf="element.statusRecipient == enumContractUserStatus.DAEMON_PROCESSING.toString()"
                    [nzColor]="'blue'" style="margin-right: 0px;">{{'search_form.connecting' | translate}}</nz-tag>
                  <!--                <nz-tag *ngIf="element.status == enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT"-->
                  <!--                        class='wait-confirm-enterprice-no-moit__tag'-->
                  <!--                        style="margin-right: 0px;">{{'search_form.wait_confirm_enterprice_no_moit' | translate}}</nz-tag>-->
                  <!-- <div nz-tooltip [nzTooltipTitle]="getCECAStatus(element)"
                    *ngIf="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable">
                    <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.FINISHED" nzStatus="success">
                    </nz-badge>
                    <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.REJECTED" nzStatus="error">
                    </nz-badge>
                    <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.PROCESSING" nzStatus="processing">
                    </nz-badge>
                  </div> -->
                  <!--                <ng-container *ngIf="element.identifyStatus == 3">-->
                  <!--                  <div style="font-size: 16px;"-->
                  <!--                       [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"-->
                  <!--                       class="d-flex align-items-center" nz-tooltip-->
                  <!--                       nzTooltipTitle="{{'enterprise_contract.identity_refused' | translate}}">-->
                  <!--                    <span class="text-primary" nz-icon nzType="close-circle" nzTheme="outline"></span>-->
                  <!--                  </div>-->
                  <!--                </ng-container>-->
                  <!--                <ng-container *ngIf="element.identifyStatus == 4">-->
                  <!--                  <div style="font-size: 16px;"-->
                  <!--                       [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"-->
                  <!--                       class="d-flex align-items-center" nz-tooltip-->
                  <!--                       nzTooltipTitle="{{'enterprise_contract.unidentified' | translate}}">-->
                  <!--                    <i class="fa fa-hourglass-end" style="color: orange;" aria-hidden="true"></i>-->
                  <!--                  </div>-->
                  <!--                </ng-container>-->
                  <!--                <ng-container *ngIf="element.identifyStatus == 5">-->
                  <!--                  <div style="font-size: 16px;"-->
                  <!--                       [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"-->
                  <!--                       class="d-flex align-items-center" nz-tooltip-->
                  <!--                       nzTooltipTitle="{{'enterprise_contract.identified' | translate}}">-->
                  <!--                    <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>-->
                  <!--                  </div>-->
                  <!--                </ng-container>-->
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell doc-status-col" style="max-width: 10%;">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!-- Trạng thái bên lập  -->
              <ng-container matColumnDef="statusOriginator">
                <mat-header-cell *matHeaderCellDef style="max-width: 10%;"
                  class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  {{'headertable.opposite_status' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element"
                  class="doc-status-col mat-cell-non-boder-right-bottom number-cell-center" style="max-width: 10%;"
                  (click)="$event.stopPropagation()">
                  <nz-tag *ngIf="element.statusOriginator === enumContractUserStatus.STOP_PROCESS.toString()"
                    style="margin-right: 0px;">
                    {{'search_form.contract_user_status_stop_process' | translate}}</nz-tag>
                  <nz-tag *ngIf="element.statusOriginator === enumContractUserStatus.NO_PROCESS.toString()"
                    style="margin-right: 0px;">
                    {{'form.document_status_wait' | translate}}</nz-tag>
                  <nz-tag *ngIf="element.statusOriginator === enumContractUserStatus.PROCESSING.toString()"
                    [nzColor]="'blue'" style="margin-right: 0px;">{{'messages.sign_processing' | translate}}
                  </nz-tag>
                  <nz-tag *ngIf="element.statusOriginator === enumContractUserStatus.REJECTED.toString()"
                    [nzColor]="'red'" style="margin-right: 0px;">{{'search_form.contract_user_status_rejected' |
                    translate}}
                  </nz-tag>
                  <nz-tag *ngIf="element.statusOriginator === enumContractUserStatus.PROCESSED.toString()"
                    [nzColor]="'green'" style="margin-right: 0px;">{{'form.document_status_signed' | translate}}
                  </nz-tag>
                  <nz-tag *ngIf="element.statusOriginator === enumContractUserStatus.CANCELLED.toString()"
                    [nzColor]="'red'" style="margin-right: 0px;">{{'search_form.cancelled' | translate}}</nz-tag>
                  <nz-tag *ngIf="element.statusOriginator == enumContractUserStatus.DAEMON_PROCESSING.toString()"
                    [nzColor]="'blue'" style="margin-right: 0px;">{{'search_form.connecting' | translate}}</nz-tag>
                  <!--                <nz-tag *ngIf="element.status == enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT"-->
                  <!--                        class='wait-confirm-enterprice-no-moit__tag'-->
                  <!--                        style="margin-right: 0px;">{{'search_form.wait_confirm_enterprice_no_moit' | translate}}</nz-tag>-->
                  <!-- <div nz-tooltip [nzTooltipTitle]="getCECAStatus(element)"
                    *ngIf="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable">
                    <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.FINISHED" nzStatus="success">
                    </nz-badge>
                    <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.REJECTED" nzStatus="error">
                    </nz-badge>
                    <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.PROCESSING" nzStatus="processing">
                    </nz-badge>
                  </div> -->
                  <!--                <ng-container *ngIf="element.identifyStatus == 3">-->
                  <!--                  <div style="font-size: 16px;"-->
                  <!--                       [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"-->
                  <!--                       class="d-flex align-items-center" nz-tooltip-->
                  <!--                       nzTooltipTitle="{{'enterprise_contract.identity_refused' | translate}}">-->
                  <!--                    <span class="text-primary" nz-icon nzType="close-circle" nzTheme="outline"></span>-->
                  <!--                  </div>-->
                  <!--                </ng-container>-->
                  <!--                <ng-container *ngIf="element.identifyStatus == 4">-->
                  <!--                  <div style="font-size: 16px;"-->
                  <!--                       [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"-->
                  <!--                       class="d-flex align-items-center" nz-tooltip-->
                  <!--                       nzTooltipTitle="{{'enterprise_contract.unidentified' | translate}}">-->
                  <!--                    <i class="fa fa-hourglass-end" style="color: orange;" aria-hidden="true"></i>-->
                  <!--                  </div>-->
                  <!--                </ng-container>-->
                  <!--                <ng-container *ngIf="element.identifyStatus == 5">-->
                  <!--                  <div style="font-size: 16px;"-->
                  <!--                       [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"-->
                  <!--                       class="d-flex align-items-center" nz-tooltip-->
                  <!--                       nzTooltipTitle="{{'enterprise_contract.identified' | translate}}">-->
                  <!--                    <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>-->
                  <!--                  </div>-->
                  <!--                </ng-container>-->
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell doc-status-col" style="max-width: 10%;">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>


              <!-- Trạng thái chứng thực  -->
              <ng-container matColumnDef="mohaConfirmStatus">
                <mat-header-cell *matHeaderCellDef style="max-width: 10%;"
                  class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  {{'headertable.status_sign' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element"
                  class="doc-status-col mat-cell-non-boder-right-bottom number-cell-center" style="max-width: 10%;"
                  (click)="$event.stopPropagation()">
                  <nz-tag *ngIf="+element.mohaConfirmStatus === 1"
                    style="margin-right: 0px;">
                    {{'contract_terminate.no_sign' | translate}}</nz-tag>
                  <nz-tag *ngIf="+element.mohaConfirmStatus === 2"
                    [nzColor]="'blue'" style="margin-right: 0px;">
                    {{'contract_terminate.signing' | translate}}</nz-tag>
                  <nz-tag *ngIf="+element.mohaConfirmStatus === 3"
                    [nzColor]="'red'" style="margin-right: 0px;">{{'contract_terminate.failed' | translate}}
                  </nz-tag>
                  <nz-tag *ngIf="+element.mohaConfirmStatus === 6"
                    [nzColor]="'green'" style="margin-right: 0px;">{{'contract_terminate.signed' | translate}}
                  </nz-tag>
                  <!-- <nz-tag *ngIf="+element.mohaConfirmStatus === 5"
                    [nzColor]="'blue'" style="margin-right: 0px;">{{'contract_terminate.wait_sign_again' | translate}}
                  </nz-tag> -->

                  <!--                <nz-tag *ngIf="element.status == enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT"-->
                  <!--                        class='wait-confirm-enterprice-no-moit__tag'-->
                  <!--                        style="margin-right: 0px;">{{'search_form.wait_confirm_enterprice_no_moit' | translate}}</nz-tag>-->
                  <!-- <div nz-tooltip [nzTooltipTitle]="getCECAStatus(element)"
                    *ngIf="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable">
                    <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.FINISHED" nzStatus="success">
                    </nz-badge>
                    <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.REJECTED" nzStatus="error">
                    </nz-badge>
                    <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.PROCESSING" nzStatus="processing">
                    </nz-badge>
                  </div> -->
                  <!--                <ng-container *ngIf="element.identifyStatus == 3">-->
                  <!--                  <div style="font-size: 16px;"-->
                  <!--                       [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"-->
                  <!--                       class="d-flex align-items-center" nz-tooltip-->
                  <!--                       nzTooltipTitle="{{'enterprise_contract.identity_refused' | translate}}">-->
                  <!--                    <span class="text-primary" nz-icon nzType="close-circle" nzTheme="outline"></span>-->
                  <!--                  </div>-->
                  <!--                </ng-container>-->
                  <!--                <ng-container *ngIf="element.identifyStatus == 4">-->
                  <!--                  <div style="font-size: 16px;"-->
                  <!--                       [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"-->
                  <!--                       class="d-flex align-items-center" nz-tooltip-->
                  <!--                       nzTooltipTitle="{{'enterprise_contract.unidentified' | translate}}">-->
                  <!--                    <i class="fa fa-hourglass-end" style="color: orange;" aria-hidden="true"></i>-->
                  <!--                  </div>-->
                  <!--                </ng-container>-->
                  <!--                <ng-container *ngIf="element.identifyStatus == 5">-->
                  <!--                  <div style="font-size: 16px;"-->
                  <!--                       [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"-->
                  <!--                       class="d-flex align-items-center" nz-tooltip-->
                  <!--                       nzTooltipTitle="{{'enterprise_contract.identified' | translate}}">-->
                  <!--                    <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>-->
                  <!--                  </div>-->
                  <!--                </ng-container>-->
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell doc-status-col" style="max-width: 10%;">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!-- Trạng thái gửi Nền tảng HĐLĐ -->
              <ng-container matColumnDef="mohaStatus">
                <mat-header-cell *matHeaderCellDef style="max-width: 10%;"
                  class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                  {{'headertable.status_send' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element"
                  class="doc-status-col mat-cell-non-boder-right-bottom number-cell-center" style="max-width: 10%;"
                  (click)="$event.stopPropagation()">
                  <nz-tag *ngIf="+element.mohaStatus === 1"
                    style="margin-right: 0px;">
                    {{'contract_terminate.no_send' | translate}}</nz-tag>
                  <nz-tag *ngIf="+element.mohaStatus === 2"
                    [nzColor]="'blue'" style="margin-right: 0px;">
                    {{'contract_terminate.sending' | translate}}</nz-tag>
                    <nz-tag *ngIf="+element.mohaStatus === 3"
                    [nzColor]="'red'" style="margin-right: 0px;">
                    {{'sign_contract_flow.error' | translate}}</nz-tag>
                  <nz-tag *ngIf="+element.mohaStatus === 4"
                    [nzColor]="'green'" style="margin-right: 0px;">{{'contract_terminate.sent' | translate}}
                  </nz-tag>
                  <!--                <nz-tag *ngIf="element.status == enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT"-->
                  <!--                        class='wait-confirm-enterprice-no-moit__tag'-->
                  <!--                        style="margin-right: 0px;">{{'search_form.wait_confirm_enterprice_no_moit' | translate}}</nz-tag>-->
                  <!-- <div nz-tooltip [nzTooltipTitle]="getCECAStatus(element)"
                    *ngIf="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable">
                    <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.FINISHED" nzStatus="success">
                    </nz-badge>
                    <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.REJECTED" nzStatus="error">
                    </nz-badge>
                    <nz-badge *ngIf="element.bctConfirmStatus === enumContractStatus.PROCESSING" nzStatus="processing">
                    </nz-badge>
                  </div> -->
                  <!--                <ng-container *ngIf="element.identifyStatus == 3">-->
                  <!--                  <div style="font-size: 16px;"-->
                  <!--                       [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"-->
                  <!--                       class="d-flex align-items-center" nz-tooltip-->
                  <!--                       nzTooltipTitle="{{'enterprise_contract.identity_refused' | translate}}">-->
                  <!--                    <span class="text-primary" nz-icon nzType="close-circle" nzTheme="outline"></span>-->
                  <!--                  </div>-->
                  <!--                </ng-container>-->
                  <!--                <ng-container *ngIf="element.identifyStatus == 4">-->
                  <!--                  <div style="font-size: 16px;"-->
                  <!--                       [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"-->
                  <!--                       class="d-flex align-items-center" nz-tooltip-->
                  <!--                       nzTooltipTitle="{{'enterprise_contract.unidentified' | translate}}">-->
                  <!--                    <i class="fa fa-hourglass-end" style="color: orange;" aria-hidden="true"></i>-->
                  <!--                  </div>-->
                  <!--                </ng-container>-->
                  <!--                <ng-container *ngIf="element.identifyStatus == 5">-->
                  <!--                  <div style="font-size: 16px;"-->
                  <!--                       [ngClass]="element.bctConfirmStatus !== enumContractStatus.DRAFT && element.isConfirmBCT && cecaEnable ? '' : 'ml-1'"-->
                  <!--                       class="d-flex align-items-center" nz-tooltip-->
                  <!--                       nzTooltipTitle="{{'enterprise_contract.identified' | translate}}">-->
                  <!--                    <span nz-icon nzType="safety" style="color: green;" nzTheme="outline"></span>-->
                  <!--                  </div>-->
                  <!--                </ng-container>-->
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell doc-status-col" style="max-width: 10%;">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!--Ngày hết hiệu lực Column -->
              <ng-container matColumnDef="expiredDate">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                  style="width: 150px;">
                  {{'enterprise-certificate_management.lbl_end_date' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                  [matTooltip]="element.expiredDate | dateformat" (click)="$event.stopPropagation()"
                  style="width: 150px;">
                  <span class="fix-width">{{ element.expiredDate | dateformat}}</span>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="width: 150px;">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!--Ngày trình ký Column -->
              <ng-container matColumnDef="submittedByATime">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                  style="max-width: 11%;">
                  {{'searchDocumentMine.lbl_submitByATime' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                  [matTooltip]="element?.submittedByATime | dateformat" (click)="$event.stopPropagation()"
                  style="max-width: 11%;">
                  <span class="fix-width">{{ element?.submittedByATime | dateformat}}</span>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 11%;">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!--Hiệu lực Column -->
              <ng-container matColumnDef="expireStatus">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                  style="max-width: 11%;">
                  {{'searchDocumentMine.lbl_validity' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                  [matTooltip]="((element.status == enumContractStatus.FINISHED && element.contractTerminationStatus == 4) ? 'searchDocumentMine.validityValue.3' : ('searchDocumentMine.validityValue.' + (element?.expireStatus ? element.expireStatus : '1'))) | translate"
                  (click)="$event.stopPropagation()" style="max-width: 11%;">
                  <nz-tag
                    [nzColor]="getColorTagExpireStatus((element.status == enumContractStatus.FINISHED && element.contractTerminationStatus == 4) ? '3' :element?.expireStatus)"
                    style="margin-right: 0px;">{{ ((element.status == enumContractStatus.FINISHED &&
                    element.contractTerminationStatus == 4) ? 'searchDocumentMine.validityValue.3' :
                    ('searchDocumentMine.validityValue.' + (element?.expireStatus ? element.expireStatus : '1'))) |
                    translate}}</nz-tag>
                  <!-- <span class="fix-width">{{ ('searchDocumentMine.validityValue.' + (element?.expireStatus ? element.expireStatus : '1')) | translate}}</span> -->
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 11%;">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>
              <!--Nhóm khách hàng Column -->
              <ng-container matColumnDef="customerGroups">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                  style="width: 150px;">
                  {{'form.group_customer' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                  [matTooltip]="transformListCustomerGroupToString(element.customerGroups)"
                  (click)="$event.stopPropagation()" style="width: 150px;">
                  <span class="fix-width">{{ transformListCustomerGroupToString(element.customerGroups) }}<span
                      class="test-deploy-cicd"></span></span>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="width: 150px;">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!--Phương thức lập Column -->
              <ng-container matColumnDef="typeId">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                  style="max-width: 130px;">
                  {{'search_form.method_creation' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                  [matTooltip]="getMethodCreation(element.typeId)" style="max-width: 130px;">
                  <span class="fix-width">{{ getMethodCreation(element.typeId) }}<span
                      class="test-deploy-cicd"></span></span>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 130px;">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!--Thương thảo hợp đồng/văn bản -->
              <ng-container matColumnDef="negotiate">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                  style="max-width: 130px;">
                  {{'negotiate_contract.label' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                  [matTooltip]="element.negotiate ? ('button.yes_sign_method_default' | translate) : ('button.no' | translate)"
                  style="max-width: 130px;">
                  <span class="fix-width">{{ element.negotiate ? ('button.yes_sign_method_default' | translate) :
                    ('button.no' | translate) }}<span class="test-deploy-cicd"></span></span>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="max-width: 130px;">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <!--Hình thức tài liệu -->
              <ng-container matColumnDef="formType">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                  style="width: 150px;">
                  {{'contract_terminate.form_type' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                  [matTooltip]="getFormType(element.formType)" style="width: 150px;">
                  <span class="fix-width">{{ getFormType(element.formType) }}<span
                      class="test-deploy-cicd"></span></span>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="width: 150px;">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>
              <!--Lý do -->
              <ng-container matColumnDef="contractMohaErrorDescription">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                  style="width: 150px;">
                  {{'header.reason' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                  [matTooltip]="element.contractMohaErrorDescription" style="width: 150px;">
                  <span class="fix-width">{{ element.contractMohaErrorDescription }}<span
                      class="test-deploy-cicd"></span></span>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell number-cell-center" style="width: 150px;">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="action" style="width: 50px" *ngIf="commonService.getIsLockedEnterprise()">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center" style="min-width: 160px">
                  {{'headertable.action' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()" class="number-cell-center"
                  style="min-width: 160px">
                  <!-- Xem chi tiết -->
                  <button mat-icon-button (click)="viewDetail(element, element.typeId)"
                    appTrackEvent="w.btn.hdtoilap.xem_chi_tiet">
                    <mat-icon matTooltip="{{'enterprise_contract.tooltips.document_view' | translate}}">
                      visibility
                    </mat-icon>
                  </button>
                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="min-width: 160px">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <ng-container matColumnDef="action" *ngIf="!commonService.getIsLockedEnterprise()">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center" style="min-width: 160px">
                  {{'headertable.action' | translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()" style="min-width: 160px"
                  class="number-cell-center">

                  <!-- Xem chi tiết -->
                  <button mat-icon-button (click)="viewDetail(element, element.typeId)"
                    appTrackEvent="w.btn.hdtoilap.xem_chi_tiet">
                    <mat-icon matTooltip="{{'enterprise_contract.tooltips.document_view' | translate}}">
                      visibility
                    </mat-icon>
                  </button>

                  <!-- Tải xuống -->
                  <button mat-icon-button type="button" (click)="openPDFByBrowser(element)"
                    appTrackEvent="w.btn.hdtoilap.tai_file">
                    <mat-icon matTooltip="{{'enterprise_contract.buttons.download' | translate}}">save_alt
                    </mat-icon>
                  </button>

                  <!-- Bắt đầu luồng -->
                  <button mat-icon-button (click)="startSignFlow(element)" *ngIf="checkPermissionCreateContract()"
                    [disabled]="element.status !== enumContractStatus.DRAFT"
                    appTrackEvent="w.btn.hdtoilap.thuc_hien_luong_ky">
                    <mat-icon *ngIf="element.status == enumContractStatus.DRAFT"
                      matTooltip="{{'enterprise_contract.buttons.start_flow' | translate}}">play_circle_outline
                    </mat-icon>
                    <mat-icon *ngIf="element.status !== enumContractStatus.DRAFT">play_circle_outline
                    </mat-icon>
                  </button>

                  <!-- Update tài liệu -->
                  <button
                    *ngIf="(mediaBreakpoint === SCREEN_SIZE.XXL || mediaBreakpoint === SCREEN_SIZE.XL) && checkPermissionCreateContract()"
                    mat-icon-button (click)="onUpdate(element)" appTrackEvent="w.btn.hdtoilap.cap_nhat"
                    [disabled]="element.status !== enumContractStatus.DRAFT">
                    <mat-icon *ngIf="element.status == 1"
                      matTooltip="{{'enterprise_contract.buttons.edit' | translate}}">
                      edit
                    </mat-icon>
                    <mat-icon *ngIf="element.status !== enumContractStatus.DRAFT">edit
                    </mat-icon>
                  </button>

                  <!-- Xóa -->
                  <button *ngIf="false" mat-icon-button (click)="delete(element.id,'',element.name)"
                    appTrackEvent="w.btn.hdtoilap.thaotackhac.xoa"
                    [disabled]="element.status !== enumContractStatus.DRAFT">
                    <i *ngIf="element.status == enumContractStatus.DRAFT" class="fa fa-trash" aria-hidden="true"
                      matTooltip="{{'enterprise_customer_management.buttons.delete' | translate}}"></i>
                    <i *ngIf="element.status !== enumContractStatus.DRAFT" class="fa fa-trash disable"
                      aria-hidden="true"></i>
                  </button>

                  <!-- Sao chép tài liệu -->
                  <button [disabled]="warningContractQuantity" *ngIf="false" mat-icon-button
                    (click)="copyDocument(element.id, element.typeId)"
                    appTrackEvent="w.btn.hdtoilap.thaotackhac.sao_chep">
                    <mat-icon *ngIf="!warningContractQuantity && checkPermissionCreateContract()"
                      matTooltip="{{'enterprise_contract.buttons.copy' | translate}}">file_copy
                    </mat-icon>
                    <mat-icon *ngIf="warningContractQuantity && checkPermissionCreateContract()">file_copy</mat-icon>
                  </button>

                  <!-- Nhắc ký HĐ -->
                  <button mat-icon-button *ngIf="false" (click)="notifySignContract(element)"
                    appTrackEvent="w.btn.hdtoilap.thaotackhac.nhac_ky_hd"
                    [disabled]="element.status !== enumContractStatus.PROCESSING">
                    <i *ngIf="element.status == enumContractStatus.PROCESSING"
                      class="fa fa-bell-o fa-fw vt-cursor-pointer" aria-hidden="true"
                      style="color: #DE0D0D;font-size: 1rem;"
                      matTooltip="{{'enterprise_customer_management.buttons.notify_sign_contract' | translate}}">
                    </i>
                    <i *ngIf="element.status !== enumContractStatus.PROCESSING"
                      class="fa fa-bell-o fa-fw vt-cursor-pointer disable" style="font-size: 1rem;"
                      aria-hidden="true"></i>
                  </button>

                  <!-- Chuyển tiếp HĐ -->
                  <button mat-icon-button *ngIf="false" (click)="forwardContract(element)"
                    appTrackEvent="w.btn.hdtoilap.thaotackhac.chuyentiephd"
                    [disabled]="element.status !== enumContractStatus.FINISHED">
                    <i *ngIf="element.status == enumContractStatus.FINISHED"
                      class="fa fa-paper-plane fa-fw vt-cursor-pointer" aria-hidden="true"
                      style="color: #07736C;font-size: 1rem;"
                      matTooltip="{{'enterprise_customer_management.buttons.forward_contract' | translate}}">
                    </i>
                    <i *ngIf="element.status !== enumContractStatus.FINISHED"
                      class="fa fa-paper-plane fa-fw vt-cursor-pointer disable" style="font-size: 1rem;"
                      aria-hidden="true"></i>
                  </button>

                  <!-- Hủy luồng -->
                  <button mat-icon-button *ngIf="false" (click)="cancelSignFlow(element.id, element)"
                    appTrackEvent="w.btn.hdtoilap.thaotackhac.huyluongky"
                    [disabled]="element.status !== enumContractStatus.PROCESSING && element.status !== enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT">
                    <mat-icon
                      *ngIf="element.status == enumContractStatus.PROCESSING || element.status == enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT"
                      style="color: #DE0D0D;" matTooltip="{{'enterprise_contract.buttons.cancel_flow' | translate}}">
                      block
                    </mat-icon>
                    <mat-icon
                      *ngIf="element.status !== enumContractStatus.PROCESSING && element.status !== enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT">
                      block
                    </mat-icon>
                  </button>

                  <!-- More icon show mobile, tablet -->
                  <button mat-icon-button [matMenuTriggerFor]="menu" appTrackEvent="w.btn.hdtoilap.thaotackhac">
                    <mat-icon matTooltip="{{'enterprise_contract.buttons.more_icon' | translate}}">more_vert</mat-icon>
                  </button>
                  <mat-menu #menu="matMenu">
                    <!-- retry -->
                    <button mat-menu-item *ngIf="element.cecaReTry" (click)="retry(element.id)">
                      <mat-icon matTooltip="{{'enterprise_contract.buttons.retry' | translate}}" class="mr-1">
                        replay
                      </mat-icon>
                      <span class="fix-width">{{'enterprise_contract.buttons.retry' | translate}}</span>
                    </button>
                    <!-- Update tài liệu -->
                    <button mat-menu-item appTrackEvent="w.btn.hdtoilap.cap_nhat"
                      *ngIf="mediaBreakpoint !== SCREEN_SIZE.XXL && mediaBreakpoint !== SCREEN_SIZE.XL"
                      (click)="onUpdate(element)" [disabled]="element.status !== enumContractStatus.DRAFT">
                      <mat-icon class="mr-1" *ngIf="element.status == 1"
                        matTooltip="{{'enterprise_contract.buttons.edit' | translate}}">edit
                      </mat-icon>
                      <mat-icon class="mr-1" *ngIf="element.status !== enumContractStatus.DRAFT">edit
                      </mat-icon>
                      <span>{{'enterprise_contract.buttons.edit' | translate}}</span>
                    </button>
                    <!-- Sao chép tài liệu -->
                    <button *ngIf="checkPermissionCreateContract()" appTrackEvent="w.btn.hdtoilap.thaotackhac.sao_chep"
                      [disabled]="warningContractQuantity || element.formType === 'CONTRACT_APPENDIX'" mat-menu-item
                      (click)="copyDocument(element.id, element.typeId)">
                      <!-- <mat-icon class="mr-1"
                                matTooltip="{{'enterprise_contract.buttons.copy' | translate}}">file_copy
                      </mat-icon> -->
                      <mat-icon class="mr-1">file_copy</mat-icon>
                      <span>{{'enterprise_contract.buttons.copy' | translate}}</span>
                    </button>
                    <!-- Xóa -->
                    <button mat-menu-item (click)="delete(element.id,'',element.name)"
                      appTrackEvent="w.btn.hdtoilap.thaotackhac.xoa"
                      [disabled]="element.status !== enumContractStatus.DRAFT">
                      <i *ngIf="element.status == enumContractStatus.DRAFT" class="fa fa-trash mr-1 p-1"
                        aria-hidden="true"
                        matTooltip="{{'enterprise_customer_management.buttons.delete' | translate}}"></i>
                      <i *ngIf="element.status !== enumContractStatus.DRAFT" class="fa fa-trash mr-1 p-1 disable"
                        aria-hidden="true"></i>
                      <span>{{'enterprise_customer_management.buttons.delete' | translate}}</span>
                    </button>
                    <!-- Trình ký xác nhận -->
                    <!-- <button mat-menu-item (click)="openDialogSignatureProcess(element.id, element)"
                      appTrackEvent="w.btn.hdtoilap.thaotackhac.trinh_ky_xac_nhan"
                      *ngIf="element.status === enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT && (!element.userApprove || element.userApprove == undefined)">
                      <mat-icon class="mr-1"
                        matTooltip="{{'enterprise_contract.buttons.signature_process' | translate}}">gesture
                      </mat-icon>
                      <mat-icon class="mr-1" *ngIf="warningContractQuantity">gesture</mat-icon>
                      <span>{{'enterprise_contract.buttons.signature_process' | translate}}</span>
                    </button> -->
                    <!-- Trình ký xác nhận lại -->
                    <!-- <button mat-menu-item (click)="openDialogReSignatureProcess(element.id, element)"
                      appTrackEvent="w.btn.hdtoilap.thaotackhac.trinh_ky_xac_nhan_lai"
                      *ngIf="element.status === enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT && element.userApprove">
                      <mat-icon class="mr-1"
                        matTooltip="{{'enterprise_contract.buttons.reassign_signature_process' | translate}}">
                        gesture
                      </mat-icon>
                      <mat-icon class="mr-1" *ngIf="warningContractQuantity">gesture</mat-icon>
                      <span>{{'enterprise_contract.buttons.reassign_signature_process' | translate}}</span>
                    </button> -->
                    <!-- Hủy trình ký xác nhận -->
                    <!-- <button mat-menu-item (click)="openDialogCancelSignatureProcess(element.id, element)"
                      appTrackEvent="w.btn.hdtoilap.thaotackhac.huy_trinh_ky_xac_nhan"
                      *ngIf="element.status === enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT && element.userApprove">
                      <mat-icon class="mr-1" style="color: #DE0D0D;"
                        matTooltip="{{'enterprise_contract.buttons.cancel_signature_process' | translate}}">
                        cancel_presentation
                      </mat-icon>
                      <mat-icon class="mr-1" *ngIf="warningContractQuantity">cancel_presentation</mat-icon>
                      <span>{{'enterprise_contract.buttons.cancel_signature_process' | translate}}</span>
                    </button> -->
                    <!-- Gửi link hợp đồng -->
                    <!-- <button mat-menu-item (click)="sendLinkContract(element.id, element)"
                      appTrackEvent="w.btn.hdtoilap.thaotackhac.gui_link_hd"
                      [disabled]="element.status === enumContractStatus.DRAFT || element.status === enumContractStatus.CANCELLED">
                      <mat-icon class="mr-1"
                        matTooltip="{{'enterprise_contract.buttons.send_link_contract' | translate}}">link
                      </mat-icon>
                      <mat-icon class="mr-1" *ngIf="warningContractQuantity">link</mat-icon>
                      <span>{{'enterprise_contract.buttons.send_link_contract' | translate}}</span>
                    </button> -->
                    <!-- Nhắc ký HĐ -->
                    <!-- <button mat-menu-item (click)="notifySignContract(element)"
                      appTrackEvent="w.btn.hdtoilap.thaotackhac.nhac_ky_hd"
                      [disabled]="element.status !== enumContractStatus.PROCESSING">
                      <i *ngIf="element.status == enumContractStatus.PROCESSING"
                        class="fa fa-bell-o fa-fw vt-cursor-pointer mr-2" aria-hidden="true"
                        style="color: #DE0D0D;font-size: 1rem;"
                        matTooltip="{{'enterprise_customer_management.buttons.notify_sign_contract' | translate}}">
                      </i>
                      <i *ngIf="element.status !== enumContractStatus.PROCESSING"
                        class="fa fa-bell-o fa-fw vt-cursor-pointer mr-2 disable" style="font-size: 1rem;"
                        aria-hidden="true"></i>
                      <span>{{'enterprise_customer_management.buttons.notify_sign_contract' | translate}}</span>
                    </button> -->

                    <!-- Chuyển tiếp HĐ -->
                    <!-- <button mat-menu-item (click)="forwardContract(element)"
                      appTrackEvent="w.btn.hdtoilap.thaotackhac.chuyentiephd"
                      [disabled]="element.status !== enumContractStatus.FINISHED">
                      <i *ngIf="element.status == enumContractStatus.FINISHED"
                        class="fa fa-paper-plane fa-fw vt-cursor-pointer mr-2" aria-hidden="true"
                        style="color: #07736C;font-size: 1rem;"
                        matTooltip="{{'enterprise_customer_management.buttons.forward_contract' | translate}}">
                      </i>
                      <i *ngIf="element.status !== enumContractStatus.FINISHED"
                        class="fa fa-paper-plane fa-fw vt-cursor-pointer mr-2 disable" style="font-size: 1rem;"
                        aria-hidden="true"></i>
                      <span>{{'enterprise_customer_management.buttons.forward_contract' | translate}}</span>
                    </button> -->

                    <!-- Hủy luồng -->
                    <button mat-menu-item (click)="cancelSignFlow(element.id, element)"
                      appTrackEvent="w.btn.hdtoilap.thaotackhac.huyluongky"
                      [disabled]="element.status !== enumContractStatus.PROCESSING && element.status !== enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT">
                      <mat-icon class="mr-1"
                        *ngIf="element.status == enumContractStatus.PROCESSING || element.status == enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT"
                        style="color: #DE0D0D;" matTooltip="{{'enterprise_contract.buttons.cancel_flow' | translate}}">
                        block
                      </mat-icon>
                      <mat-icon class="mr-1"
                        *ngIf="element.status !== enumContractStatus.PROCESSING && element.status !== enumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT">
                        block
                      </mat-icon>
                      <span>{{'enterprise_contract.buttons.cancel_flow' | translate}}</span>
                    </button>

                    <!-- Chia sẻ hợp đồng cho đối tác -->
                    <!-- <button mat-menu-item (click)="shareContract(element)"
                      appTrackEvent="w.btn.hdtoilap.thaotackhac.chuyentiephd"
                      [disabled]="element.status !== enumContractStatus.FINISHED">
                      <mat-icon *ngIf="element.status === enumContractStatus.FINISHED" class="mr-1"
                        style="color: #07736C;font-size: 1rem;">share</mat-icon>
                      <mat-icon *ngIf="element.status !== enumContractStatus.FINISHED" class="mr-1"
                        style="font-size: 1rem;">share</mat-icon>
                      <span>{{'contract_share_partner.manage_share_with_partners' | translate}}</span>
                    </button> -->

                    <!-- Thanh lý hợp đồng văn bản -->
                    <!-- <button mat-menu-item (click)="terminationContract(element)"
                      *ngIf="element.formType !== 'CONTRACT_TERMINATION'"
                      [disabled]="element.status !== enumContractStatus.FINISHED || (element.status === enumContractStatus.FINISHED && (element.contractTerminationStatus === 4 || element.contractTerminationStatus === 2)) || !checkPermissionCreateContract()"> -->
                      <!-- <mat-icon *ngIf="element.status === enumContractStatus.FINISHED" class="mr-1" style="color: #07736C;font-size: 1rem;">contract_edit</mat-icon>
                      <mat-icon *ngIf="element.status !== enumContractStatus.FINISHED"  style="font-size: 1rem;">contract_edit</mat-icon> -->
                      <!-- <svg class="mr-1"
                        *ngIf="element.status === enumContractStatus.FINISHED && element.contractTerminationStatus !== 4 && element.contractTerminationStatus !== 2 && checkPermissionCreateContract()"
                        xmlns="http://www.w3.org/2000/svg" style="fill: #07736C;" height="24px" viewBox="0 -960 960 960"
                        width="24px" fill="#e3e3e3">
                        <path
                          d="M360-600v-80h360v80H360Zm0 120v-80h360v80H360Zm120 320H200h280Zm0 80H240q-50 0-85-35t-35-85v-120h120v-560h600v361q-20-2-40.5 1.5T760-505v-295H320v480h240l-80 80H200v40q0 17 11.5 28.5T240-160h240v80Zm80 0v-123l221-220q9-9 20-13t22-4q12 0 23 4.5t20 13.5l37 37q8 9 12.5 20t4.5 22q0 11-4 22.5T903-300L683-80H560Zm300-263-37-37 37 37ZM620-140h38l121-122-18-19-19-18-122 121v38Zm141-141-19-18 37 37-18-19Z" />
                      </svg>
                      <svg class="mr-1"
                        *ngIf="element.status !== enumContractStatus.FINISHED || (element.status === enumContractStatus.FINISHED && (element.contractTerminationStatus === 4 || element.contractTerminationStatus === 2)) || !checkPermissionCreateContract()"
                        xmlns="http://www.w3.org/2000/svg" style="fill: rgba(0, 0, 0, 0.38);" height="24px"
                        viewBox="0 -960 960 960" width="24px" fill="#e3e3e3">
                        <path
                          d="M360-600v-80h360v80H360Zm0 120v-80h360v80H360Zm120 320H200h280Zm0 80H240q-50 0-85-35t-35-85v-120h120v-560h600v361q-20-2-40.5 1.5T760-505v-295H320v480h240l-80 80H200v40q0 17 11.5 28.5T240-160h240v80Zm80 0v-123l221-220q9-9 20-13t22-4q12 0 23 4.5t20 13.5l37 37q8 9 12.5 20t4.5 22q0 11-4 22.5T903-300L683-80H560Zm300-263-37-37 37 37ZM620-140h38l121-122-18-19-19-18-122 121v38Zm141-141-19-18 37 37-18-19Z" />
                      </svg>
                      <span>{{'contract_terminate.contract_termination' | translate}}</span>
                    </button> -->
                     <!-- Tạo mới phụ lục HĐ -->
                     <button mat-menu-item appTrackEvent="w.btn.hdtoilap.tao_moi_phu_luc"
                        *ngIf="!warningContractQuantity && !commonService.getIsLockedEnterprise() && checkPermissionCreateContract() && element.formType == 'CONTRACT'"
                        (click)="onAddDocument(element)" [disabled]="element.mohaStatus != '4'">
                        <mat-icon style="color: #DE0D0D;" class="mr-1" *ngIf="element.mohaStatus == 4"
                          matTooltip="{{'enterprise_contract.buttons.add_pl' | translate}}">add_circle
                        </mat-icon>
                        <mat-icon class="mr-1" *ngIf="element.mohaStatus != 4"
                          matTooltip="{{'enterprise_contract.buttons.add_pl' | translate}}">add_circle
                        </mat-icon>
                        <span>{{'enterprise_contract.buttons.add_pl' | translate}}</span>
                      </button>

                      <!-- Chứng thực lại -->
                    <button mat-menu-item (click)="reAuthenticate(element.id)"
                    appTrackEvent="w.btn.hdtoilap.thaotackhac.chungthuclai" *ngIf="element.mohaConfirmStatus == 3">
                    <i class="fa fa-refresh mr-1 p-1" style="font-size: 16px; color: #07736C !important;"
                      aria-hidden="true"
                      matTooltip="{{'enterprise_customer_management.buttons.sign_again' | translate}}"></i>
                    <span>{{'enterprise_customer_management.buttons.sign_again' | translate}}</span>
                  </button>
                  </mat-menu>

                </mat-cell>
                <mat-footer-cell *matFooterCellDef class="skeleton-footer-cell" style="min-width: 160px">
                  <span class="skeleton-cell"></span>
                </mat-footer-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row"
                [cdkDetailRow]="row" (toggleChange)="onToggleChange($event,row)">
              </mat-row>
              <!-- hang skeleton trong bang: mat-footer-row render doc lap voi data nen ton tai
                   ca khi bang chua co du lieu; moi cot co mat-footer-cell rieng can theo
                   displayedColumns nen skeleton can theo dung cot; an/hien qua class theo isTableLoading -->
              <mat-footer-row *matFooterRowDef="displayedColumns"
              class="table-skeleton-row"
              [class.table-skeleton-hidden]="!isTableLoading"></mat-footer-row>
            </mat-table>
          </div>

          <!-- Pagination -->
          <app-pagination [(paginate)]="paginate" (pageChange)="onFilterData($event.page, $event.pageSize)" [isShowNoRecord]="!isTableLoading">
          </app-pagination>
        </mat-expansion-panel>
      </mat-accordion>


    </mat-card-content>
  </mat-card>

  <ng-template #iconError>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_4400_41288)">
        <rect y="0.00390625" width="24" height="24" rx="12" fill="white" />
        <path
          d="M12 0.00390625C5.383 0.00390625 0 5.38691 0 12.0039C0 18.6209 5.383 24.0039 12 24.0039C18.617 24.0039 24 18.6209 24 12.0039C24 5.38691 18.617 0.00390625 12 0.00390625ZM17.657 14.8319C18.048 15.2229 18.048 15.8559 17.657 16.2459L16.243 17.6599C15.852 18.0509 15.219 18.0509 14.829 17.6599L12.001 14.8319L9.173 17.6599C8.782 18.0509 8.149 18.0509 7.759 17.6599L6.345 16.2459C5.954 15.8549 5.954 15.2219 6.345 14.8319L9.173 12.0039L6.345 9.17591C5.954 8.78491 5.954 8.15191 6.345 7.76191L7.759 6.34791C8.15 5.95691 8.783 5.95691 9.173 6.34791L12.001 9.17591L14.829 6.34791C15.22 5.95691 15.853 5.95691 16.243 6.34791L17.657 7.76191C18.048 8.15291 18.048 8.78591 17.657 9.17591L14.829 12.0039L17.657 14.8319Z"
          fill="#EE0033" />
      </g>
      <defs>
        <clipPath id="clip0_4400_41288">
          <rect y="0.00390625" width="24" height="24" rx="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </ng-template>

  <ng-template #iconProcess>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24.0037" rx="12" fill="#F9B44E" />
      <path
        d="M5.33283 12.0019C5.33153 10.7897 5.66106 9.60025 6.2859 8.56159C6.91074 7.52293 7.80719 6.6745 8.87864 6.10773C9.9501 5.54096 11.1559 5.27736 12.3661 5.34532C13.5763 5.41329 14.7451 5.81026 15.7463 6.49343L14.5442 8.00155C14.4898 8.07072 14.4649 8.1586 14.475 8.24603C14.4851 8.33346 14.5294 8.41335 14.5982 8.46825C14.6493 8.50943 14.7115 8.53429 14.7769 8.53959L19.2252 8.91829C19.2689 8.92204 19.3129 8.91715 19.3546 8.90389C19.3964 8.89064 19.4351 8.86928 19.4686 8.84104C19.5021 8.81281 19.5297 8.77825 19.5498 8.73933C19.57 8.70042 19.5822 8.65792 19.5859 8.61427C19.5894 8.57061 19.5844 8.5267 19.5713 8.48492L18.2098 4.23459C18.1915 4.17725 18.1579 4.12595 18.1127 4.08616C18.0675 4.04636 18.0124 4.01955 17.9531 4.00858C17.9332 4.00412 17.9129 4.00166 17.8925 4.00124C17.8423 4.00129 17.7929 4.01265 17.7477 4.03447C17.7026 4.05628 17.663 4.088 17.6318 4.12725L16.5784 5.44869C15.3804 4.60844 13.9746 4.11328 12.5145 4.01724C11.0544 3.92119 9.59589 4.22793 8.29815 4.904C7.0004 5.58008 5.91322 6.59953 5.15518 7.85117C4.39713 9.10281 3.99734 10.5386 3.9994 12.0019C3.9994 12.1787 4.06964 12.3483 4.19467 12.4733C4.31971 12.5983 4.48929 12.6686 4.66612 12.6686C4.84294 12.6686 5.01252 12.5983 5.13756 12.4733C5.26259 12.3483 5.33283 12.1787 5.33283 12.0019Z"
        fill="white" />
      <path
        d="M19.3339 11.335C19.1571 11.335 18.9875 11.4052 18.8625 11.5302C18.7374 11.6553 18.6672 11.8249 18.6672 12.0017C18.6685 13.2138 18.339 14.4033 17.7141 15.4419C17.0893 16.4806 16.1928 17.329 15.1214 17.8958C14.0499 18.4626 12.8441 18.7262 11.6339 18.6582C10.4237 18.5902 9.25497 18.1933 8.25372 17.5101L9.45581 16.002C9.49328 15.9548 9.51724 15.8983 9.52516 15.8386C9.53308 15.7788 9.52465 15.718 9.50078 15.6627C9.47691 15.6074 9.43849 15.5595 9.38959 15.5243C9.3407 15.4891 9.28317 15.4678 9.22313 15.4626L4.77478 15.0839C4.73113 15.0802 4.68717 15.0851 4.64541 15.0983C4.60365 15.1116 4.56491 15.1329 4.53141 15.1612C4.49792 15.1894 4.47031 15.224 4.45018 15.2629C4.43005 15.3018 4.41778 15.3443 4.41409 15.3879C4.41063 15.4316 4.41561 15.4755 4.42876 15.5173L5.79019 19.7689C5.80858 19.8263 5.84215 19.8776 5.88734 19.9174C5.93254 19.9572 5.98767 19.984 6.04688 19.995C6.06681 19.9994 6.08713 20.0019 6.10755 20.0023C6.15768 20.0022 6.20716 19.9909 6.25229 19.9691C6.29743 19.9473 6.33706 19.9155 6.36824 19.8763L7.42165 18.5549C8.61965 19.3951 10.0254 19.8903 11.4855 19.9863C12.9457 20.0824 14.4041 19.7756 15.7019 19.0995C16.9996 18.4235 18.0868 17.404 18.8448 16.1524C19.6029 14.9007 20.0027 13.465 20.0006 12.0017C20.0006 11.8249 19.9304 11.6553 19.8054 11.5302C19.6803 11.4052 19.5107 11.335 19.3339 11.335Z"
        fill="white" />
    </svg>
  </ng-template>

  <ng-template #iconFinish>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="#52C41A" />
      <path d="M6.03979 13.2378L9.66368 16.5932L18.1194 6.52686" stroke="white" stroke-width="1.95886"
        stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  </ng-template>
</div>
